import { templateIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadTemplate } from "../lists/loaders.ts";
import { TemplatePage } from "../lists/template-page.tsx";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { RecordPending } from "../tasks/pending.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/lists/templates/$id");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id } = route.useParams();
  return viewer === null ? <NoAccessPage /> : <TemplatePage viewer={viewer} templateId={id} />;
};

export const Route = createFileRoute("/_app/lists/templates/$id")({
  params: {
    parse: ({ id }) => ({ id: parameterOrNotFound(templateIdSchema, id) }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => loadTemplate(context.data, params.id),
  pendingComponent: () => <RecordPending kind="list" />,
  component: Page,
});
